import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

const RetailerOnboardingBrandMatchPage = lazy(
  () => import("../../pages/RetailerOnboardingBrandMatchPage")
);

export function SanjayRamanRoutes() {
  return (
    <Switch>
      <Route
        path="/sr/retailer-onboarding-brand-match"
        component={RetailerOnboardingBrandMatchPage}
      />
    </Switch>
  );
}

export const slug = "sr";
